// extracted by css-extract-rspack-plugin
export default {"newPatientTag":"newPatientTag-YjJneU"};